<template>
  <v-app>
    <router-view></router-view>
    <error-info v-model="messageComputed" v-if="messageType == 'error'" />
    <warning-info v-model="messageComputed" v-else-if="messageType == 'warning'" />
    <success-info v-model="messageComputed" v-else-if="messageType == 'success'" />
    <overlay-progress v-model="loading" />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import ErrorInfo from '@/components/atoms/ErrorInfo'
import WarningInfo from '@/components/atoms/WarningInfo'
import SuccessInfo from '@/components/atoms/SuccessInfo'
import Message from '@/mixin/message-utils.js'
import OverlayProgress from '@/components/atoms/base/progress/OverlayProgress'
import Loading from '@/mixin/loading-utils.js'

export default {
  name: 'App',

  mixins: [Message, Loading],

  components: { ErrorInfo, WarningInfo, SuccessInfo, OverlayProgress },

  computed: {
    ...mapGetters(['message', 'messageType', 'loading']),

    messageComputed: {
      get() {
        return this.message
      },
      set() {
        this.closeMessage()
      },
    },
  },
}
</script>

<style>
@import './assets/style.css';
</style>
